import { motion } from "framer-motion";
import { Plus, Eye } from "lucide-react";
import { formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, onView, index = 0 }) => {
  const { add } = useCart();
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };

  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.6, delay: (index % 6) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      onMouseMove={onMove}
      data-testid={`product-card-${product.id}`}
      className="spotlight group flex flex-col border border-navy/10 bg-white p-4 transition-shadow duration-500 hover:shadow-[0_30px_60px_-30px_rgba(10,37,64,0.35)]"
    >
      <button onClick={() => onView(product)} className="clip-frame-sm relative aspect-[4/3] w-full overflow-hidden bg-ice" data-testid={`product-image-btn-${product.id}`}>
        <img src={product.image} alt={product.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
        {(product.badge || product.featured) && <span className="absolute left-3 top-3 bg-gold px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-navy">{product.badge || "Sélection"}</span>}
        {product.stock <= 0 && <span className="absolute inset-0 grid place-items-center bg-navy/60 font-mono text-xs uppercase tracking-widest text-white">Rupture</span>}
      </button>
      <div className="mt-5 flex flex-1 flex-col">
        <p className="eyebrow text-royal">{product.category}</p>
        <h3 className="mt-2 font-display text-lg font-semibold leading-snug text-navy" data-testid={`product-name-${product.id}`}>{product.name}</h3>
        <p className="mt-2 line-clamp-2 text-sm text-slate-500">{product.description}</p>
        <div className="mt-5 flex items-end justify-between gap-3">
          <span className="font-display text-xl font-bold text-navy" data-testid={`product-price-${product.id}`}>{formatPrice(product.price)}</span>
          <div className="flex gap-2">
            <button onClick={() => onView(product)} data-testid={`product-view-${product.id}`} className="grid h-10 w-10 place-items-center border border-navy/15 text-navy transition-colors duration-300 hover:border-royal hover:text-royal" aria-label="Aperçu">
              <Eye className="h-4 w-4" />
            </button>
            <button
              onClick={() => add(product)}
              disabled={product.stock <= 0}
              data-testid={`product-add-${product.id}`}
              className="flex h-10 items-center gap-1.5 bg-navy px-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-royal disabled:cursor-not-allowed disabled:opacity-40"
            >
              <Plus className="h-4 w-4" /> Ajouter
            </button>
          </div>
        </div>
      </div>
    </motion.article>
  );
};
